/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { HeaderPayoutDetailContentPlugin } from './header.service';
import { loadingPayoutDetailConfig } from '../../config/loading.config';
import { updatePaymentPayoutDetailConfig } from '../../config/updatepayment.config';
import { errorPayoutDetailConfig } from '../../config/error.config';
import { notificationsPayoutDetailConfig } from '../../config/notifications.config';
import { headerPayoutDetailConfig } from '../../config/header.config';
import { FeaturePayoutDetailPlugin } from './featureSection.service';
import { featurePayoutDetailConfig } from '../../config/featuresSection.config';
export interface IStaticPayoutDetailContentPluginMethods
  extends IPluginMethodMap {
  getStaticPayoutDetailContentSync(args?: any): any;
}

export class StaticPayoutDetailContentPlugin implements IAgentPlugin {
  readonly methods: IStaticPayoutDetailContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticPayoutDetailContentSync:
        this.getStaticPayoutDetailContentSync.bind(this),
    };
  }

  getStaticPayoutDetailContentSync(args?: any) {
    return {
      header: headerPayoutDetailConfig,
      loading: loadingPayoutDetailConfig?.loading,
      updatePayout: updatePaymentPayoutDetailConfig,
      error: errorPayoutDetailConfig,
      notifications: notificationsPayoutDetailConfig,
      feature: featurePayoutDetailConfig,
    };
  }
}
